import { useMutation } from "react-query";
import downloadUnclaimedMoneyCsv from "../services/downloadUnclaimedMoneyCsv";

function useDownloadUnclaimedMoneyCsv() {
  return useMutation(
    ["download-unclaimed-money-csv"],
    downloadUnclaimedMoneyCsv
  );
}

export default useDownloadUnclaimedMoneyCsv;
